// extracted by mini-css-extract-plugin
export default {"wrap":"CloseButton_wrap__GovAk","cross":"CloseButton_cross__QS95z","paths":"CloseButton_paths__NoXHO"};